export type { UserPrefs } from '#web-oura-tools/types/prefs'
export type { OuraUser } from '#web-oura-tools/types/user'

export enum ApiProviders {
  OUTO_CLOUD,
}

export interface AuthConfig {
  apiProviders?: ApiProviders[]

  enableAutoLogin?: boolean
  userPreferencesKey?: string
}

export interface CustomClaims {
  aud?: string
  firebase?: {
    sign_in_attributes?: {
      groups?: string[] | string
    }
  }
}

export interface UserDetails {
  uid: string
  email: string
  groups: string[]
  audience: string
}

export interface TokenDetails extends UserDetails {
  isSessionExpired: boolean

  authTimeInMillis: number
  expiryTimeInMillis: number
}

export type AppEnvironment = 'sandbox' | 'staging' | 'release'
export type CloudEnvironment = 'dev' | 'test' | 'stage' | 'prod'
